import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { AppBillingResponse } from '@playq/services-taxman';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const corpQueryBillingQueryKeys: unknown[] = ['corp', 'query', 'billing', 'query'];

export const useQueryBillingQuery = (
  from: Date,
  till: Date,
  options?: IUseQueryOptionsExtended<AppBillingResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => corpQueryBillingQueryKeys.concat(from, till), [from, till]);
  return useEitherQuery(keys, () => services2.queryBillingService.query(from, till), {
    placeholderData: keepPreviousData,
    ...options,
  });
};
